import React from 'react';

/**
 * Component that only re-renders if the answer (or its validation error) has changed.  Without this, every form
 * component is re-rendered when _any_ form value changes, even in other components.
 */
export default class AnswerWrapper extends React.Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.answer !== this.props.answer ||
      nextProps.error !== this.props.error
    );
  }

  render() {
    return this.props.children;
  }
}
